// MuiMultiAutocomplete
import {
  Autocomplete,
  Avatar,
  Box,
  Chip,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { s3baseUrl } from "src/config";
const useStyles = makeStyles((theme) => ({
  chip: {
    "& .MuiChip-deleteIcon": {
      color: "#00AB55", // Customize the color as needed
    },
  },
}));
const MuiMultiAutocomplete = ({
  label,
  options,
  value,
  onChange,
  disabled,
  fixedOptions = [],
  required = false,
  disableCloseOnSelect = false,
  loading = false,
  showIcon = false,
}) => {
  console.log(options, "options _auto");
  console.log(value, "value _auto");
  // ---------------------------------------------------------
  const classes = useStyles();
  const handleChange = (newValue) => {
    if (newValue) {
      onChange(newValue);
    }
  };
  // ---------------------------------------------------------
  return (
    <Autocomplete
      multiple
      id="tags-filled"
      options={options}
      value={value}
      disableCloseOnSelect={disableCloseOnSelect}
      disabled={disabled}
      filterSelectedOptions={true}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      onChange={(event, value) =>
        handleChange([
          ...fixedOptions,
          ...value.filter(
            (option) =>
              fixedOptions.findIndex(
                (fixedOption) => fixedOption._id == option._id
              ) === -1
          ),
        ])
      }
      // renderTags={(value, getTagProps) =>
      //   value.map((option, index) => (
      //     <Chip
      //       variant="outlined"
      //       label={`${option.label}`}
      //       disabled={fixedOptions.indexOf(option) !== -1}
      //       // deleteIcon={<CancelIcon sx={{ color: "red" }} />}
      //       classes={{ root: classes.chip }}
      //       {...getTagProps({ index })}
      //     />
      //   ))
      // }
      renderTags={(value, getTagProps) =>
        loading
          ? []
          : value.map((option, index) => (
              <Chip
                variant="outlined"
                label={`${option.label}`}
                disabled={fixedOptions.indexOf(option) !== -1}
                classes={{ root: classes.chip }}
                {...getTagProps({ index })}
                avatar={
                  showIcon ? (
                    <Avatar
                    src={s3baseUrl + option.image }
                    alt={option.label}
                  />
                  ) : undefined
                }
              />
            ))
      }
      // ----- Only Show custom options when showIcons is "true"
      {...(showIcon && {
        renderOption: (props, option) => (
          <Box component="li" {...props}>
            <Avatar
              src={s3baseUrl + option.image}
              alt={option.label}
              sx={{ width: 24, height: 24, mr: 1 }}
            />
            <Typography variant="body1">{option.label}</Typography>
          </Box>
        ),
      })}

      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          variant="outlined"
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default MuiMultiAutocomplete;

MuiMultiAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
